import { render } from "./UpgradePlanModal.vue?vue&type=template&id=a725402c"
import script from "./UpgradePlanModal.vue?vue&type=script&lang=js"
export * from "./UpgradePlanModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__